module.exports = __webpack_public_path__ + "img/华为云.bd804b8d.png";